import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import McpTools from './tools';
import McpQueueLoading from './mcp-loading';
import "./index.scss";
import { useMemo } from 'react';
import { McpItemContext } from '../context';

const McpItem = observer((props) => {
  const {
    chatStore,
    messageItem,
    isLastMessage,
    onRenew,
    handleSend,
  } = props;
  
  const {
    events: messageEvents,
    isMcpShare,
  } = messageItem;

  const {
    mcpStore,
  } = chatStore;

  const isAITyping = useMemo(() => {
    const isAITyping = (chatStore.isAITyping && chatStore.lastMessage?.msg_id == messageItem.msg_id);
    return isAITyping;
  }, [messageItem, chatStore.isAITyping, chatStore.lastMessage]);

  const events = messageItem.msg_id == mcpStore.panelMessageId 
    ? mcpStore.displayEvents
    : mcpStore.getFixedEvents(messageEvents);

  const hasLevel1Cards = useMemo(() => {
    const eventsString = JSON.stringify(events);
    return eventsString.includes('displayIndex');
  }, [events]);

  return (
    <McpItemContext.Provider value={{
      isAITyping,
    }}>
    <div>
      {
       events.map((item, index) => {
          const {
            type,
          } = item;

          switch(type){
            case "steps":{
              return (
                <McpTools 
                  key={`steps_${index}`}
                  mcpStore={mcpStore} 
                  events={item.list} 
                  messageItem={messageItem} 
                  onRenew={onRenew} 
                  handleSend={handleSend}
                  isMcpShare={isMcpShare}
                  isLastMessage={isLastMessage}
                  >
                </McpTools>
              )
            }
            default:{
              return null;
            }
          }
        })
      }
      {
        hasLevel1Cards
        ? null
        : (
          <McpQueueLoading chatStore={chatStore} isLastMessage={isLastMessage} messageItem={messageItem} />
        )
      }
    </div>
    </McpItemContext.Provider>
  )
});
export default McpItem;